// Test
export const test = '/test/list'
// notification-type
export const notificationList = 'master-notification-type/list'
export const notificationStore = 'master-notification-type/store'
export const notificationUpdate = 'master-notification-type/update'
export const notificationToggleStatus = 'master-notification-type/toggle-status'
export const notificationDelete = 'master-notification-type/destroy'
// notification-setting
export const notificationSettingList = 'master-notification-setting/list'
export const notificationSettingStore = 'master-notification-setting/store'
export const notificationSettingUpdate = 'master-notification-setting/update'
export const notificationSettingToggleStatus = 'master-notification-setting/toggle-status'
export const notificationSettingDelete = 'master-notification-setting/destroy'
// notification-template
export const notificationTemplateList = 'notification-template/list'
export const notificationTemplateStore = 'notification-template/store'
export const notificationTemplateUpdate = 'notification-template/update'
export const notificationTemplateToggleStatus = 'notification-template/toggle-status'
export const notificationTemplateDelete = 'notification-template/destroy'
// circulate-notice
export const circulateNoticeList = 'notification-circulate-notice/list'
export const circulateNoticeStore = 'notification-circulate-notice/store'
export const circulateNoticeUpdate = 'notification-circulate-notice/update'
export const circulateNoticeToggleStatus = 'notification-circulate-notice/toggle-status'
export const circulateNoticeDelete = 'notification-circulate-notice/destroy'
// message-template
export const messageTemplateList = 'message-template/list'
export const messageTemplateDataList = 'message-template/list-data'
export const messageTemplateStore = 'message-template/store'
export const messageTemplateUpdate = 'message-template/update'
export const messageTemplateToggleStatus = 'message-template/toggle-status'
export const messageTemplateDelete = 'message-template/destroy'
// Notification Stting
export const notificationSettingDataList = 'notification-setting/list'
export const notificationSettingDataStore = 'notification-setting/store'
export const notificationSettingDataUpdate = 'notification-setting/update'
export const notificationSettingDataToggleStatus = 'notification-setting/toggle-status'
export const notificationSettingDataDelete = 'notification-setting/destroy'
/** Received notification */
export const receivedNotificationApi = '/notification-received/list'
export const receiviedNotificationStatusChangeApi = ''
